export default "__VITE_ASSET__D2j8rBNy__"